/**
 * LizaDocs Chat Widget
 *
 * An embeddable chat widget for AI-powered documentation support.
 *
 * Usage:
 *
 * 1. ES Module (recommended):
 * ```html
 * <script type="module" src="https://app.lizadocs.com/widget/widget.js"></script>
 * <lizadocs-chat widget-id="your-widget-id"></lizadocs-chat>
 * ```
 *
 * 2. IIFE (for GTM or legacy):
 * ```html
 * <script src="https://app.lizadocs.com/widget/widget.iife.js"></script>
 * <lizadocs-chat widget-id="your-widget-id"></lizadocs-chat>
 * ```
 *
 * Attributes:
 * - widget-id (required): Your widget ID from the LizaDocs dashboard
 * - theme: "light" | "dark" - Override the theme
 * - position: "bottom-right" | "bottom-left" - Override position
 * - api-url: Custom API URL (for self-hosted)
 *
 * Programmatic API:
 * ```javascript
 * const widget = document.querySelector('lizadocs-chat');
 * widget.open();       // Open chat
 * widget.close();      // Close chat
 * widget.toggle();     // Toggle open/close
 * widget.identify({    // Identify user
 *   email: 'user@example.com',
 *   name: 'John Doe'
 * });
 * widget.destroy();    // Clean up
 * ```
 *
 * Events:
 * - widget:opened - Chat window opened
 * - widget:closed - Chat window closed
 * - message:sent - User sent a message
 * - message:received - Bot response received
 * - conversation:started - New conversation started
 * - error - Error occurred
 */

import { LizaDocsChat } from './LizaDocsChat';

// Register custom element
if (!customElements.get('lizadocs-chat')) {
  customElements.define('lizadocs-chat', LizaDocsChat);
}

// Export for programmatic use
export { LizaDocsChat };
export type { WidgetConfig, Message, UserIdentity } from './types/messages';
